import React from "react";
import Chat from "../../features/Chat/components/Chat";
import Header from "../../components/Header/Header";
import useSelectChat from "#hooks/selectChat/useSelectChat";

const ChatPage = () => {
  const { isAgent } = useSelectChat();

  const title = isAgent ? "디지털 상담 (상담원)" : "디지털 상담";
  const sectionClass = isAgent
    ? "p-hasHeader bg-stone-c-50 min-h-screen"
    : "p-hasHeader";

  return (
    <section className={sectionClass}>
      <Header title={title} />
      <Chat isAgent={isAgent} />
    </section>
  );
};

export default ChatPage;
